import { useEffect, useState } from 'react';

import type { ContentStatus as BoardStatus } from '@confluence/content-types-header/entry-points/ContentStatus';
import type { MoreActions } from '@confluence/content-types-header/entry-points/MoreActions';
import type { MainActions } from '@confluence/content-types-header/entry-points/MainActions';
import { contentMoreActionsService } from '@confluence/content-types-bridge/entry-points/content-more-actions-service';
import { contentMainActionsService } from '@confluence/content-types-bridge/entry-points/content-main-actions-service';
import { contentCollaboratorsService } from '@confluence/content-types-bridge/entry-points/content-collaborators-service';
import { contentBoardStatusService } from '@confluence/content-types-bridge/entry-points/content-board-status-service';
import type { CanvasCollaborators } from '@confluence/team-presence/entry-points/presenceTypes';

export const useDatabaseHeaderActions = () => {
	const [mainActions, setMainActions] = useState<MainActions | null>(null);
	const [collaborators, setCollaborators] = useState<CanvasCollaborators>({
		collaborators: [],
		me: null,
	});
	const [boardStatus, setBoardStatus] = useState<BoardStatus | null>(null);
	const [moreActions, setMoreActions] = useState<MoreActions | null>(null);

	useEffect(() => {
		contentMainActionsService.onActionsUpdate((mainAction) => {
			setMainActions(mainAction);
		});

		contentCollaboratorsService.onActionsUpdate((collaborator) => {
			setCollaborators(collaborator);
		});

		contentBoardStatusService.onActionsUpdate((status) => {
			setBoardStatus(status);
		});

		contentMoreActionsService.onActionsUpdate((moreAction) => {
			setMoreActions(moreAction);
		});
	}, [setMainActions, setCollaborators, setBoardStatus, setMoreActions]);

	return {
		mainActions,
		collaborators,
		contentStatus: boardStatus,
		moreActions,
	};
};
